export default "__VITE_ASSET__HBaRJ0B8__"